import React from 'react';
import classNames from 'classnames';
import Icon, { IconSize } from '../Icon';
import { IconName } from '../Icon/constants';

export interface AvatarProps {
  id?: string;
  alt?: string;
  className?: string;
  src?: string;
  label?: string;
  iconName?: IconName;
  iconSize?: IconSize;
}

const Avatar: React.FC<AvatarProps> = (props: AvatarProps) => {
  const {
    id,
    alt,
    className,
    src,
    label,
    iconName = '',
    iconSize = 'x-small',
  } = props;

  const avatarClass = classNames('ui-avatar', className);
  const avatarIconClass = classNames('ui-avatar-icon');
  const avatarImageWrapperClass = classNames('ui-avatar-image-wrapper');

  return (
    <div className={avatarClass}>
      <div className={avatarImageWrapperClass}>
        {src && <img id={id} src={src} alt={alt} />}
        {!src && iconName && (
          <div className={avatarIconClass}>
            <Icon name={iconName} size={iconSize} />
          </div>
        )}
      </div>
      {label && <div className="ui-avatar-label">{label}</div>}
    </div>
  );
};

export default Avatar;
